import { render, staticRenderFns } from "./resultCreateDebt.vue?vue&type=template&id=f530031c&"
import script from "./resultCreateDebt.vue?vue&type=script&lang=js&"
export * from "./resultCreateDebt.vue?vue&type=script&lang=js&"
import style0 from "./resultCreateDebt.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports